import styled, { css } from 'styled-components';
import type { ImageProps } from './Image';
import { Ease } from '../../../styles/easing';
import { TransitionDuration } from '../../../styles/variables';

const coverCss = css`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
`;

const containCss = css`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
`;

const aspectRatioCss = css`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

export const StyledImage = styled.div<
  Partial<ImageProps> & {
    $cover?: boolean;
    $contain?: boolean;
    $roundedBorder?: boolean;
    $aspectRatio?: [number, number];
  }
>`
  width: 100%;
  position: relative;
  height: auto;

  ${({ $cover }) => $cover && coverCss}
  ${({ $contain }) => $contain && containCss}
`;

export const StyledPicture = styled.picture<{ $aspectRatio?: [number, number] }>`
  ${({ $aspectRatio }) => $aspectRatio && aspectRatioCss}
`;

type StyledImageElementProps = {
  $cover?: boolean;
  $contain?: boolean;
};

export const StyledImageElement = styled.img<StyledImageElementProps>`
  width: 100%;
  top: 0;
  left: 0;
  opacity: 0;
  transition: opacity ${TransitionDuration.Normal} ${Ease.EaseOut};

  &.lazyloaded {
    opacity: 1;
  }

  ${(props) => props.$cover && `position: absolute; height: 100%; object-fit: cover;`}
  ${(props) => props.$contain && `position: absolute; height: 100%; object-fit: contain;`}
`;
